import {interfaces} from 'inversify'
import {register} from 'dna-react-ioc'
import {ProfileStoreSymbol} from '@/pages/Profile/Profile'
import {SendbirdChatStore} from '@/stores'
import {
    ISendbirdChatStore,
    SendbirdChatContainerStoreSymbol
} from '@/stores/sendbird-chat/ISendbirdChatStore'

export const sendbirdInitState = () => {
    register<ISendbirdChatStore>(SendbirdChatContainerStoreSymbol)
        .toDynamicValue(
            (context: interfaces.Context) =>
                new SendbirdChatStore(context.container.get(ProfileStoreSymbol))
        )
        .inSingletonScope()
}
